import React from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { observable } from 'mobx';

import { Table, DateValue, Column, Button, Pager } from '@smartplatform/ui';
import store from '../../store';

const PER_PAGE = 20;

@withRouter @observer
export default class List extends React.Component {
	
	@observable records = [];
	@observable isLoading = true;
	@observable page = 1;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.isLoading = true;
		this.records = await store.model.Document.find({
			where: {
				docGroup: { like: '0.2F161.2F16J.%' }
			},
			limit: PER_PAGE,
			skip: (this.page - 1) * PER_PAGE,
			order: 'date desc',
		});
		this.isLoading = false;
	};
	
	onPageChange = page => {
		this.page = page;
		this.init();
	};
	
	render() {
		return <>
			<p>Заседания комитетов</p>
			<Pager
				current={this.page}
				onChange={this.onPageChange}
				totalCount={this.records.totalCount}
			/>
			{this.records.length > 0 &&
				<Table records={this.records} rootPath="/admin" path="committeesessions">
					<Column width={80} property="date" label="Дата"><DateValue format="DD.MM.YYYY" /></Column>
					<Column property="name" label="Наименование" />
				</Table>
			}
		</>;
	}
	
}
